import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { InputTags } from 'react-bootstrap-tagsinput'
import 'react-bootstrap-tagsinput/dist/index.css'
import { saveBlockedAddress, getBlockedAddress } from '../../helper/apiHelper.js';
import { toast, Bounce } from 'react-toastify';

function Filter() {
    const [state, setState] = useState([]);
    const refreshMessage = useSelector((state) => state.refreshMessage);
    const dispatch = useDispatch();

    const handleTagsChange = (value) => {
        const newTags = value.values;
        const uniqueTags = new Set();
        const validTags = [];

        newTags.forEach(tag => {
            if (tag.trim() !== '' && !uniqueTags.has(tag)) {
                uniqueTags.add(tag);
                validTags.push(tag);
            }
        });
        setState(validTags);
    };

    const save = async () => {
        let data = state.join(',');
        const tagValue = document.getElementById("custom-tags").value;
        if (tagValue) {
            data += `,${tagValue}`;
        }
        const result = await saveBlockedAddress(data);
        if (result) {
            toast.success("Saved!", {
                position: "top-center",
                transition: Bounce,
            });
        } else {
            toast.error("Something went wrong!", {
                position: "top-center",
                transition: Bounce,
            });
        }
        fetchData();
        setState([])
        dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage });
    }

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await getBlockedAddress();
            if (response) {
                setState(response.address.split(','));
            }

        } catch (error) {
            console.error('Error fetching general settings:', error);
        }
    };

    return (
        <>
            <div className='col-6'>
                <div className='settings-filter-section'>
                    <div>
                        <label htmlFor="fname" className='general-menu-text'>Blocked Addresses: <span className="profile-welcome">(separate each address with a comma)</span></label>
                        <div className='mt-2 filter-tag'>
                            <InputTags
                                key={state.length}
                                values={state}
                                onTags={handleTagsChange}
                                className="custom-tags"
                                id="custom-tags"
                            />
                        </div>
                    </div>
                    <div className="save-settings-btn mt-3 d-flex justify-content-center">
                        <button className='general-save-btn' onClick={async () => {
                            await save();
                        }}>save</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Filter;
